<template src="./template.html"></template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';

import Btn from "@/components/elements/buttons";
import LogosSVG from "@/assets/images/logosSVG";
import PriceCard from "./priceCard.vue";
import InputSelect from '@/components/elements/inputs/select.vue';
import InputText from '@/components/elements/inputs/text.vue';
import Popup from '@/components/global/popup';
import Checkbox from '@/components/elements/inputs/checkbox.vue';
import Calendar from '@/components/elements/inputs/calendar.vue';
import Toggle from "@/components/elements/inputs/toggle.vue";
import EventBus from '@/eventBus.js';
import i18n from "@/i18n";
import dateMixin from "@/mixins/date";
import pickupTimeMixin from "@/mixins/pickupTime";

export default {
  name: 'ToggleCard',
  components: {
    Btn,
    LogosSVG,
    PriceCard,
    Popup,
    Checkbox,
    InputSelect,
    InputText,
    Calendar,
    Toggle,
  },
  mixins: [dateMixin, pickupTimeMixin],
  props: {
    senderHandlingType: {
      type: [String, Number],
      default: '',
    },
    pickupLocationId: {
      type: [String, Number],
      default: '',
    },
    editShipmentDroppointNo: {
      type: [String, Number],
      default: '',
    },
    pickupDate: {
      type: [String, Date],
      default: '',
    },
    showPrices: {
      type: [Boolean],
      default: false,
    },
    product: {
      type: Object,
      default: {},
    },
    enabledInsuranceCategory: {
      type: Boolean,
      default: false,
    },
    disableBookButton: {
      type: Boolean,
      default: false,
    },
    isOpened: {
      type: Boolean,
      default: false,
    },
    enabledProducts: {
      type: Array,
      default: () => {
        return [];
      },
    },
    selectedServices: {
      type: Array,
      default: () => {
        return [];
      },
    },
    editPickupTimeFrom: {
      type: [String],
      default: '',
    },
    editPickupTimeUntil: {
      type: [String],
      default: '',
    },
    editPickupTimeZone: {
      type: [String],
      default: '',
    },
    editPickupDriverNote: {
      type: [String],
      default: '',
    },
    customsData: {
      type: [Object],
      required: false
    },
  },
  data() {
    return{
      selectedPickupProduct: null,
      pickupProductId: '',
      pickupAction: '',
      notPlannedPickupAction: 'move_not_planned_shipments_into_booked',
      newPickupDate: '',
      pickupDriverNote: '',
      insuranceCategory: '',
      insuranceCategoriesOptions: [],
      isOpenedPopup: false,
      shipmentNotificationList: [
        {
          text: 'EOD',
          value: 1,
        },
      ],
      shipmentNotification: '1',
      pickupToggle: false,
      pickup_driver_note: '',
      otherNotificationEvent: '',
      freight_booking_confirmation_no: '',
      // Checkboxes
      selectedReciever: true,
      selectedShipper: false,
      selectedMe: false,
      selectedOther: false,
      selectedStatusChange: false,
      selectedDeviations: false,
      selectedDeliver: false,
      // Other
      APIerror: '',
      otherMail: '',
      droppointNo: '',
      user_vat_percent: '',
      droppointAddressOptions: [],
    };
  },
  computed: {
    ...mapGetters([
      'get_booking_systems',
      'get_user',
      'get_active_subaccount',
      'get_currency',
      'get_payer_carriers',
      'get_is_ship365',
      'get_shipper_by_id'
    ]),
    showPickupTimeZoneMessage() {
      const cond1 = this.pickupTimeData.pickupTimeZone !== this.getBrowserTimeZone;

      if (parseInt(this.pickupProductId) === 0) {
        return false;
      }

      if (this.isPickupToday()) {
        return cond1;
      }

      return false;
    },
    showReadyToCloseTimeMessage() {
      const cond1 = !!(
        this.selectedPickupProduct &&
        this.pickupTimeData.pickupTimeFrom &&
        this.selectedPickupProduct.close_time &&
        this.selectedPickupProduct.ready_time &&
        this.showPickupTimes &&
        this.getTimeOptions.until &&
        this.getTimeOptions.until.length === 0);

      return this.selectedPickupProduct && (cond1 || !this.isPickupToday());
    },
    getReadyToCloseTimeMessage() {
      if (!this.selectedPickupProduct) return '';
      const closeTime = this.selectedPickupProduct.close_time;
      const readyTime = this.selectedPickupProduct.ready_time;
       if (!closeTime || !readyTime) return '';

      return i18n.tc('pickup_time_info_message', 2, {
        ready_time: readyTime,
        close_time: closeTime
      });
    },
    getNoProductsAvailableMessage() {
      return i18n.tc('no_valid_pickup_product_options_for_today_msg');
    },
    getPickupProductOptions() {
      let products = this.product.pickup.products
        .filter((product) => {
          if (!product.has_errors) {
            return product;
          }
        }).map((product) => {
          if (!this.pickupProductId) {
            this.pickupProductId = product.shipping_product_id;
            this.selectedPickupProduct = product;
          }
          const text = `${product.shipping_product_name} (${product.total_price} DKK)`;
          return {text: text, value: product.shipping_product_id};
        });

      if (!products.length) {
        products = [{text: 'no_valid_pickup_product_options', value: 0}];
        this.pickupProductId = 0;
      }

      console.log(products)
      return products;
    },
    showPickupToggle() {
      //Show pickup toggle when product is drop off and pickup handling type
      const handlingTypes = this.product.product_handling_type.split(', ');
      let cond4 = this.product.product_handling_type === '3';
      let cond2 = handlingTypes.includes('1') && handlingTypes.includes('2');
      let cond3 = handlingTypes.includes('1') && handlingTypes.includes('3'); // && !!this.product?.pickup?.show_book_pickup_toggle;
      //If sender handling type is drop off and ... show pickup toggle
      let baseCond = cond2 || cond3 || cond4;

      if (baseCond && this.product?.pickup?.message === 'booked_pickup_exist_current_time_is_after_close_time') {
        return true;
      }

      if (this.product?.pickup?.message === 'booked_pickup_exist_but_this_product_is_not_allowed_so_it_will_be_created_in_not_planned_pickup') {
        return false;
      }

      if (this.product?.pickup?.message === 'pickup_has_been_booked_on_this_address') {
        return true;
      }

      return baseCond && parseInt(this.senderHandlingType) === 3;
    },
    showPickupTimes() {
      // Case for bulk pickup handling type and import or three way product direction type
      //let isBulkPickupAndImportOrThreeWay = (this.product.product_handling_type.split(', ').includes('3')) && ([3, 4].includes(parseInt(this.product.direction_type)));

      //If product is dropp off only then do not show pickup times
      if (this.product.product_handling_type === '1') {
        return false;
      }

      //If sender handling type is 'pickup at shipper' or 'pickup at other location' and there is no booked pickup, show time options
      if ([1, 2].includes(parseInt(this.senderHandlingType)) && (this.product?.pickup?.message === 'remember_to_book_pickup')) {
        return true;
      }

      //Pickup toggle is on or product handling type is pickup
      return (this.pickupToggle === true) || (this.product.product_handling_type === '2'); // isBulkPickupAndImportOrThreeWay;
    },
    showFreightConfirmationNo() {
      const showConfirmNoProducts = [
        'FedExInternationalPriorityFreightDtdExport',
        'FedExInternationalPriorityFreightDtdImport',
        'FedExInternationalEconomyFreightDtdExport',
        'FedExInternationalEconomyFreightDtdImport',
        'FedExRegionalEconomyFreight'
      ];
      return this.get_is_ship365 && showConfirmNoProducts.includes(this.product.carrier_product_name);
    },
    getPickupNotificationTxt() {
      if (this.product.pickup.message === 'pickup_has_been_booked_on_this_address' && this.pickupToggle) {
       // return `${this.$t('toggle_on_pickup_has_been_booked_on_this_address')} ${this.$t('between')} ${this.product.pickup.pickup_from} ${this.$t('and')} ${this.product.pickup.pickup_until}`;
        return `<p style="font-weight: 500;">${this.$t('be_aware_pickup_text')}</p> ${this.$t('toggle_on_pickup_has_been_booked_on_this_address')} ${this.$t('between')} ${this.product.pickup.pickup_from} ${this.$t('and')} ${this.product.pickup.pickup_until}`;
      } else if (this.product.pickup.message === 'pickup_has_been_booked_on_this_address') {
        return `${this.$t('pickup_has_been_booked_on_this_address')} ${this.$t('between')} ${this.product.pickup.pickup_from} ${this.$t('and')} ${this.product.pickup.pickup_until}`;
      } else if (this.product.pickup.message === 'booked_pickup_exist_but_this_product_is_not_allowed_so_it_will_be_created_in_new_not_planned_pickup') {
        return `${this.$t('booked_pickup_exist_but_this_product_is_not_allowed_so_it_will_be_created_in_new_not_planned_pickup')} </br> ${this.product.pickup.pickup_from} ${this.product.pickup.pickup_until}`;
      } else {
        return this.$t(this.product.pickup.message);
      }
    },
    showNotPlannedPickupMessage() {
      if (parseInt(this.senderHandlingType) === 3 && !this.pickupToggle) return false;

      if(['booked_pickup_exist_but_this_product_is_not_allowed_so_it_will_be_created_in_not_planned_pickup'].includes(this.product?.pickup?.message)) {
        return false;
      }

      return this.product.pickup && this.product.pickup.not_planned;
    },
    showPickupMessage() {
      //If is drop off sender and pickup toggle is off
      return !(parseInt(this.senderHandlingType) === 3 && !this.pickupToggle);
    },
    visibleBookingButton() {
      if(this.disableBookButton) return false;
      if(this.get_user.book_permission_type == 3) return false;
      if(this.get_active_subaccount.book_approval_type == 3) return false;
      return true;
    },
    hasTransportPrice() {
      const pd = this.product.prices_data;
      if (!pd || pd.response_type === 'error') return false;

      const hasTransportInLineItems = (items) => {
        if (!Array.isArray(items)) return false;
        return items.some(item =>
          item.type === 'product' && item.sales_price != null && item.sales_price != 0
        );
      };

      if (pd.response_type === 'shipment') {
        return hasTransportInLineItems(pd.prices);
      }

      if (pd.response_type === 'colli') {
        const collies = Object.values(pd.prices || {});
        if (collies.length === 0) return false;
        return collies.every(colli => hasTransportInLineItems(colli.colli_prices?.[0]));
      }

      return false;
    },
    getTransitTimeString() {
      if (this.product.estimated_time.value === '') {
        return this.$t('no_estimation');
      } else if (parseInt(this.product.estimated_time.value) === 0) {
        return this.$t('same_day');
      } else if (parseInt(this.product.estimated_time.value) === 1) {
        return this.$t('delivery_within_hours', [24]);
      } else {
        return this.$t('delivery_within_days', [this.product.estimated_time.value]);
      }
    },
    getDeliveryTypeString() {
      const deliveryTypes = this.product.product_delivery_type.split(', ');
      const translatedArray = [];
      deliveryTypes.forEach(type => {
        if(parseInt(type) === 1) {
          translatedArray.push(this.$t('delivery_to_door'))
        }
        if(parseInt(type) === 2) {
          translatedArray.push(this.$t('delivery_to_drop_point'))
        }
      })

      if (translatedArray) {
        return translatedArray.join(', ')
      }
      return '-'
    },
    isDisabledByService() {
      // console.log('isDisabledByService')
      // console.log(this.enabledProducts)
      // console.log(this.product.shipping_product_id)
      // console.log(this.selectedServices)
      if( this.enabledProducts.length > 0 ){
        if(!this.enabledProducts.includes(this.product.shipping_product_id)){
          return true;
        }
      }

      if( this.selectedServices.length > 0 && this.enabledProducts.length == 0) {
        return true;
      }
    },
    isDisabled() {
      if('error' in this.product.prices_data){
        if( this.product.prices_data.error.message == `Error with product id ${this.product.prices_data.error.product}. Error: agreement_product_data_not_found`){
          return false;
        }
        if( this.product.prices_data.error.message == `Error with product id ${this.product.prices_data.error.product}. Error: sales_product_price_data_not_found`){
          return false;
        }
        return true;
      } else {
        return false;
      }
    },
    isDisabledByPayer() {
      if (this.customsData?.freight_paid_by == 4 && !this.get_payer_carriers?.items?.find(item => item.shipping_agent_id == this.product.shipping_agent_id)) {
        return true;
      }
      return false
    },
    isDisabledByAPI() {
      if(this.product.api_errors.length > 0){
        this.product.api_errors.forEach((error) => {
          if(error.type == 'dot'){
            this.APIerror = this.$t(error.text, {
              a: error.params[0],
              b: error.params[1],
              c: error.params[2],
            })
          } else {
            this.APIerror = this.$t(error.text)
          }
        })
        return true;
      } else {
        return false;
      }
    },
    getPickupTimeZoneMessage()
    {
      return i18n.tc('pickup_time_and_zone_message', 2, {
        time: this.pickupTimeData.pickupTimeZoneCurrentTime,
        zone: this.pickupTimeData.pickupTimeZone
      })
    },
    getTimeOptions() {
      this.returnHoursArrayFunction(this.pickupTimeData.pickupTimeZone)
      return this.returnHoursArray;
    },
  },
  created() {
    if (this.get_booking_systems){
      const systemSettings = this.get_booking_systems.items[0];
      const otherNotificationEvents = systemSettings.other_shipment_notification_events_array || []
      this.shipmentNotification = systemSettings.shipment_notification.toString();

      if (otherNotificationEvents && otherNotificationEvents.includes('deviations')) {
        this.selectedDeviations = true;
      }
      if (otherNotificationEvents && otherNotificationEvents.includes('change')) {
        this.selectedStatusChange = true;
      }
      if (otherNotificationEvents && otherNotificationEvents.includes('delivered')) {
        this.selectedDeliver = true;
      }
    }
    if(this.product.insurance_categories != null){
      for (const key in this.product.insurance_categories) {
        this.insuranceCategoriesOptions.push({
          text: `${this.$t(key)}`,
          value: key,
        })
      }

      if (this.product.insurance_category) {
        this.insuranceCategory = this.product.insurance_category;
      } else {
        this.insuranceCategory = this.insuranceCategoriesOptions[0].value;
      }
    }

    if (this.product.droppoints != null) {
      this.product.droppoints.forEach((dp) => {
        if (dp.number) {
          const text = `(${dp.driving_distance} km) ${dp.company_name}, ${dp.address}, ${dp.zip_code} ${dp.city}`;
          this.droppointAddressOptions.push({
            value: dp.number,
            text: text
          })
        }

        if (this.editShipmentDroppointNo) {
          this.droppointNo = this.editShipmentDroppointNo;
        }

        //First droppoint is the closest one, so preselect him
        if (dp.number && !this.droppointNo) {
          this.droppointNo = dp.number
        }
      })
    }

    //If product is dropp off only then do not set pickup times
    if (this.product.product_handling_type !== '1' ) {
      this.pickupDriverNote = this.editPickupDriverNote;
      this.pickupTimeData.pickupTimeUntil = this.editPickupTimeUntil;
      this.pickupTimeData.pickupTimeFrom  = this.editPickupTimeFrom;
      this.pickupTimeData.pickupTimeZone  = this.editPickupTimeZone;
    }

    //If we have 'pickup time until' and 'pickup time from' already set, activate toggle (draft, copy)
    this.pickupToggle = !!(this.pickupTimeData.pickupTimeUntil && this.pickupTimeData.pickupTimeFrom);

    //If product is bulk pickup set pickup toggle to false
    if (this.product?.pickup?.products) {
      this.pickupToggle = false;
    }

    //If there is already booked pickup on this address set toggle to off, so it can go in bulk
    if (this.product?.pickup?.message === 'pickup_has_been_booked_on_this_address') {
      this.pickupToggle = false;
    }

    if (this.customsData?.freight_payer_id && this.customsData?.freight_paid_by == 4) {
      this.$store.dispatch('GET_PAYER_CARRIERS', {id: this.customsData.freight_payer_id});
    }
    if (this.product.sender_time_zone) {
      this.pickupTimeData.pickupTimeZone = this.product.sender_time_zone;
      this.returnHoursArrayFunction(this.pickupTimeData.pickupTimeZone);
    }

    if (this.product.sender_current_time) {
      this.pickupTimeData.pickupTimeZoneCurrentTime = this.product.sender_current_time
    }
  },
  methods: {
    returnHoursArrayFunction(pickupTimeZone) {
      if (this.selectedPickupProduct) {
        //Bulk pickup = separated pickup for bunch of shipments
        this.setBulkPickupTimeRange(this.selectedPickupProduct, pickupTimeZone, !this.showPickupTimes);
      } else {
        //Regular pickup goes as addition to freight (pickup + freight for the given shipment)
        this.setNormalPickupTimeRange(pickupTimeZone, !this.showPickupTimes)
      }
    },
    setSelectedPickupProduct(val) {
      const selectedProducts = this.product.pickup.products.filter((pickupProduct) => {
        if (parseInt(val) === parseInt(pickupProduct.shipping_product_id)) {
          return pickupProduct;
        }
      });

      this.selectedPickupProduct = selectedProducts[0];
    },
    getTotalPriceText(product) {
      this.user_vat_percent = this.get_user.vat_user_percent;
      return Number(product.prices_data.vat_percent) ?  this.$t('total_incl_vat') : this.$t('total');
    },
    changeInsuranceCategory(val) {
      this.$emit('updateInsuranceCategory', val);
    },
    otherNotification() {
      this.selectedOther = !this.selectedOther;
      if(!this.selectedOther) {
        this.otherMail = '';
      }
    },
    selectOptions(obj) {
      const options = [];
      for (const property in obj) {
        options.push({ text: obj[property], value: parseInt(property) });
      }
      return options;
    },
    selected() {
      if(this.isDisabled || this.isDisabledByService || this.isDisabledByAPI) return;
      this.$emit('selected', {
        allowedServices: this.product.allowed_services,
        product: this.product,
      });
    },
    /**
     * True when the selected pickup_time_from has already passed.
     *
     * The comparison is made in the pickup address timezone (the offset the user
     * sees in the popup), never in browser local time - a shipper in Denmark
     * booking a US pickup would otherwise be judged against the wrong clock.
     */
    isPickupTimeFromInPast() {
      const timeZone = this.pickupTimeData.pickupTimeZone;
      const pickupTimeFrom = this.pickupTimeData.pickupTimeFrom;
      if (!timeZone || !pickupTimeFrom) return false;

      const shipDate = this.newPickupDate ? this.newPickupDate : this.pickupDate;
      if (!shipDate) return false;

      let pickupDate;
      if (shipDate instanceof Date) {
        pickupDate = this.getFormatedDate(shipDate).date;
      } else {
        // Calendar emits 'YYYY-MM-DD' through its modelConfig mask, but the same
        // prop can be seeded with a user-formatted date - date_format is a
        // localStorage setting - so reuse the shared multi-format parser.
        // Never new Date('2026-08-26'): that is parsed as UTC midnight and lands
        // on the previous day for any browser behind UTC.
        const parsed = this.parseUnknownDate(String(shipDate));
        pickupDate = parsed.isValid ? parsed.toFormat('yyyy-MM-dd') : '';
      }

      // Unrecognised date - leave the booking to the existing checks, do not block.
      if (!/^\d{4}-\d{2}-\d{2}$/.test(pickupDate)) return false;

      const currentDate = this.getTimeInGMT(timeZone, 'date');

      if (pickupDate !== currentDate) {
        return pickupDate < currentDate;
      }

      return pickupTimeFrom < this.getTimeInGMT(timeZone);
    },
    dispatchShipment() {
      let notificationReciever = [];
      if(this.selectedReciever) notificationReciever.push({name: 'receiver', email: ''});
      if(this.selectedShipper) notificationReciever.push({name: 'shipper', email: ''})
      if(this.selectedMe) notificationReciever.push({name: 'me', email: ''})
      if(this.selectedOther) notificationReciever.push({name: 'other', email: this.otherMail})

      let otherNotifications = [];
      if(this.selectedStatusChange) otherNotifications.push('change');
      if(this.selectedDeviations) otherNotifications.push('deviations')
      if(this.selectedDeliver) otherNotifications.push('delivered')
      if(this.showPickupTimes){
        if(this.pickupTimeData.pickupTimeFrom == '' || this.pickupTimeData.pickupTimeUntil == '') {
          console.log('pickup time from/to required for handing type PICKUP');
         // EventBus.$emit('checkSubmitErrors');
          this.$store.commit('SHOW_NOTIFICATION_BAR', {
            message: 'pickup time from/to required for handing type PICKUP',
            type: 'alert-window'
          });
          return;
        };

        if (this.isPickupTimeFromInPast()) {
          this.$store.commit('SHOW_NOTIFICATION_BAR', {
            message: this.$t('pickup_time_from_in_past'),
            type: 'alert-window'
          });
          return;
        }
      }

      let notPlannedAction = this.notPlannedPickupAction;
      if (notPlannedAction === 'dont_move_not_planned_shipments_into_booked' || !this.showNotPlannedPickupMessage) {
        notPlannedAction = '';
      }

      const notPlannedPickupActionTxt = this.pickupAction ? `,${notPlannedAction}` : notPlannedAction;
      this.$emit('triggerShipment', {
        shipmentNotificationType: this.shipmentNotification,
        notification_receiver: notificationReciever,
        other_notification_event: otherNotifications,
        pickup_time_from: this.pickupTimeData.pickupTimeFrom,
        pickup_time_until: this.pickupTimeData.pickupTimeUntil,
        pickup_time_zone: this.pickupTimeData.pickupTimeZone,
        pickup_driver_note: this.pickupDriverNote,
        pickup_product_id: this.pickupProductId,
        pickup_ship_date: this.newPickupDate ? this.newPickupDate : this.pickupDate,
        pickup_action: `${this.pickupAction}${notPlannedPickupActionTxt}`,
        droppoint_no: this.droppointNo,
        product: this.product,
        freight_booking_confirmation_no: this.freight_booking_confirmation_no
      });
    },
    openPopup() {
      this.isOpenedPopup = true;
    },
    closePopup() {
      this.isOpenedPopup = false;
    },
    changeNotification() {
      this.isOpenedPopup = false;
    },
    getLocation() {
        if (!this.pickupLocationId || !this.pickupTimeData.pickupTimeZone || !this.showPickupTimes) return null;
        return this.get_shipper_by_id(this.pickupLocationId);
    }
  },
  watch: {
    pickupToggle(val) {
      if(!val){
        this.pickupTimeData.pickupTimeFrom = '';
        this.pickupTimeData.pickupTimeUntil = '';
        this.pickupDriverNote = '';
        this.pickupAction = '';
        this.notPlannedPickupAction = '';
        this.pickupProductId = '';
      }
    },
  },
}
</script>
